import React from "react";
import {
    TableBody,
    TableCell,
    TableRow,
} from "@mui/material";
import {useIntl} from "react-intl";
import MerchandisingRow from "./MerchandisingRow";
import ListingTableHead from "components/Product/Table/ListingTableHead";
import ListingRowsSkeleton from "components/Product/Table/ListingRowsSkeleton";
import ListingEmptyState from "components/Product/Table/ListingEmptyState";

export default function MerchandisingTableContent({products, selectedProducts, handleSelectSingle, handleGlobalCheckbox, globalCheck, loading, onResetFilters})
{
    const intl = useIntl();
    const noProducts = products && products.length === 0;

    // same columns as the product list, without the Scoring column (the
    // merchandising view has no per-retailer scoring context)
    const tableHeads = [
        {id: "ranking", numeric: false, label: intl.formatMessage({id: "retailer.product.list.header.ranking"}), tooltipId: "retailer.product.list.header.ranking.tooltip"},
        {id: "article", numeric: false, label: intl.formatMessage({id: "retailer.product.list.header.article"})},
        {id: "lowestPrice", numeric: true, label: intl.formatMessage({id: "retailer.product.list.header.price"}), hideOnMobile: true},
        {id: "sales", numeric: true, label: intl.formatMessage({id: "retailer.product.list.header.sales"}), hideOnMobile: true},
        {id: "stock", numeric: true, label: intl.formatMessage({id: "retailer.product.list.header.stock"}), hideOnMobile: true},
    ];

    return (
        <>
            <ListingTableHead
                rows={tableHeads}
                mergeCheckboxInFirstCell={true}
                showCheckbox={true}
                onSelectAllClick={handleGlobalCheckbox}
                isSelectAllChecked={globalCheck}
                checkboxDisabled={loading || noProducts}
            />
            <TableBody>
                {loading &&
                    <ListingRowsSkeleton withScoring={false}/>
                }
                {!loading && noProducts &&
                    <TableRow>
                        <TableCell colSpan={5} sx={{padding: '0 !important'}}>
                            <ListingEmptyState
                                titleId={"retailer.product.list.noResult.title"}
                                descriptionId={"retailer.product.list.noResult.description"}
                                ctaLabelId={"retailer.product.list.noResult.cta"}
                                ctaVariant={"secondary"}
                                onCtaClick={onResetFilters}
                            />
                        </TableCell>
                    </TableRow>
                }
                {!loading && products && products.map((item) => (
                    <MerchandisingRow
                        product={item}
                        key={item.id}
                        isSelected={selectedProducts.indexOf(item.id) !== -1}
                        handleSelectSingle={handleSelectSingle}
                    />
                ))}
            </TableBody>
        </>
    )
}
